import * as FileSaver from 'file-saver';
import { IRenderFunction, ScrollablePane, ScrollbarVisibility, Sticky, StickyPositionType } from 'office-ui-fabric-react';
import { PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CheckboxVisibility, ConstrainMode, DetailsList, DetailsListLayoutMode, IColumn, IDetailsHeaderProps, Selection } from 'office-ui-fabric-react/lib/DetailsList';
import { Dialog, DialogType } from 'office-ui-fabric-react/lib/Dialog';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { ComboBox, IComboBoxOption, IComboBoxProps } from 'office-ui-fabric-react/lib/index';
import { Link } from 'office-ui-fabric-react/lib/Link';
import { MarqueeSelection } from 'office-ui-fabric-react/lib/MarqueeSelection';
import { SearchBox } from 'office-ui-fabric-react/lib/SearchBox';
import { IStackTokens, Stack } from 'office-ui-fabric-react/lib/Stack';
import { mergeStyles } from 'office-ui-fabric-react/lib/Styling';
import * as React from 'react';
import * as XLSX from 'xlsx';
import { IAgentView } from '../../../models/IAgentView';
import { IAgentViewExcel } from '../../../models/IAgentViewExcel';
import { ICountry } from '../../../models/ICountry';
import { IModalDialog } from '../../../models/IModalDialog';
import ConnectionContext from '../../../utils/ConnectionContext';
import AgentProfile from '../AgentProfile/AgentProfile';
import { IAgentViewProps } from './IAgentViewProps';
import { IAgentViewState } from './IAgentViewState';
initializeIcons();

export const ExportCSV = ({ csvData, fileName }) => {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const exportToCSV = (csvData, fileName) => {
        if (csvData.length > 0) {
            const ws = XLSX.utils.json_to_sheet(csvData);
            const wb = { Sheets: { 'AgentCharges': ws }, SheetNames: ['AgentCharges'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            FileSaver.saveAs(data, fileName + fileExtension);
        }
    }
    return (
        <PrimaryButton text="Export" onClick={(e) => exportToCSV(csvData, fileName)} className={submitButton} iconProps={{ iconName: "Export" }} />
    )
}
const panel = mergeStyles({
    alignContent: "center",
    display: 'block',
    background: '#ffffff',
    boxShadow: '0px 0px 5px 5px #C9C9C9',
    minHeight: '100px',
    padding: '10px',
    minWidth: '200px',
    fontSize: "13px", color: '#005269'
});
const numberAlignment = mergeStyles({ textAlign: 'right' });
const numberAlignmentTotal = mergeStyles({ textAlign: 'right', fontWeight: 'bold', color: '#005269' });
const filterPanel = mergeStyles({ textAlign: "center", border: "1px solid #005269", borderRadius: "5px" });
const userMessage = mergeStyles({ fontSize: "13px", fontWeight: "bold", paddingTop: "15px" });
const innerPanel = mergeStyles({ display: "inline-block", margin: "0 auto", width: "auto", color: '#005269' });
const textBoxPanel = mergeStyles({ display: "inline-block", verticalAlign: "middle", padding: "5px", fontSize: "13px", margin: "0 auto" });
const printButtonPanel = mergeStyles({ display: "none", verticalAlign: "middle", padding: "5px", fontSize: "13px", margin: "0 auto" });
const listPanel = mergeStyles({ height: '80vh', position: 'relative' });
const submitButton = mergeStyles({ backgroundColor: '#73797D', marginRight: "5px" });
export interface IDetailsList {
    key: string;
    agentId: string;
    firmName: string;
    jurisdiction: string;
    category: string;
    particulars: string;
    officialfee: number;
    professionalfee: number;
    otherexpenses: number;
    total: number;
}
const getStyles = () => {
    return {
        root: {
            maxWidth: "100%",
            responsiveMode: true,
            color: '#005269',
            width: "40%",
            minWidth: "40%"
        }
    }
};
export default class AgentView extends React.Component<IAgentViewProps, IAgentViewState>
{
    private connectionContext: ConnectionContext;
    private selection: Selection;
    private allItems: IDetailsList[];
    private allItemsExcel: IDetailsList[];
    private columns: IColumn[];
    private dialog: IModalDialog;
    private serviceError: string;
    private contentError: string;
    private jurisdictionError: string;
    private agentViewExcel: IAgentViewExcel[];
    constructor(props: IAgentViewProps, state: IAgentViewState) {
        super(props);
        this.connectionContext = this.props.connectionContext;
        this.serviceError = '';
        this.contentError = '';
        this.jurisdictionError = '';
        this.selection = new Selection({
            onSelectionChanged: () => this.setState({ selectionDetails: this.getSelectionDetails() })
        });
        this.allItems = [];
        this.columns = [
            {
                key: 'column1', name: 'Agent Name', fieldName: 'firmName', minWidth: 100, maxWidth: 120, isResizable: true,
                onRender: (item: IDetailsList) => (
                    <Link onClick={this.getAgentProfile.bind(this, item)} >{item.firmName}</Link>)
            },
            { key: 'column2', name: 'Jurisdiction', fieldName: 'jurisdiction', minWidth: 100, maxWidth: 100, isResizable: true },
            { key: 'column3', name: 'IP Type', fieldName: 'category', minWidth: 100, maxWidth: 100, isResizable: true },
            { key: 'column4', name: 'Type of Service', fieldName: 'particulars', minWidth: 200, maxWidth: 400, isResizable: true },
            { key: 'column5', name: 'Official Fee (€)', fieldName: 'officialfee', minWidth: 100, maxWidth: 100, isResizable: false, className: numberAlignment },
            { key: 'column6', name: 'Professional Fee (€)', fieldName: 'professionalfee', minWidth: 100, maxWidth: 100, isResizable: false, className: numberAlignment },
            { key: 'column7', name: 'Other Expenses (€)', fieldName: 'otherexpenses', minWidth: 100, maxWidth: 100, isResizable: false, className: numberAlignment },
            { key: 'column8', name: 'Total Charges (€)', fieldName: 'total', minWidth: 100, maxWidth: 100, isResizable: false, className: numberAlignmentTotal }
        ];
        this.state = {
            loading: false,
            items: this.allItems,
            selectionDetails: this.getSelectionDetails(),
            jurisdictions: [],
            selectedJurisdiction: [],
            services: [],
            selectedService: {
                key: '',
                text: ''
            },
            particulars: [],
            selectedParticular: {
                key: '',
                text: ''
            },
            agentId: "",
            hideModel: true,
            selectedItems: []
        };
        this.dialog = {
            hideDialog: true,
            accessDeniedDialog: false,
            dialogMessage: '',
            dialogBody: '',
            mode: ''
        };
        this.agentViewExcel = [];
        this.allItemsExcel = [];
    }
    public async componentDidMount() {
        this.getAgentInfo();
        this.loadServices();
        this.loadCountries();
    }
    private getAgentInfo = async (): Promise<void> => {
        try {
            this.allItems = [];
            this.agentViewExcel = [];
            let agentlist: IAgentView[] = await this.props.connectionContext.get("AgentView")
            this.setState((prevState: IAgentViewState): IAgentViewState => {
                agentlist = agentlist.sort((a, b) => a.total > b.total ? 1 : -1);
                agentlist.forEach((item: IAgentView) => {
                    this.allItems.push({
                        key: item.id, agentId: item.agentId, firmName: item.firmName, jurisdiction: item.serviceJurisdiction,
                        category: item.category, particulars: item.particulars, total: item.total, officialfee: item.officialfee,
                        professionalfee: item.professionalfee, otherexpenses: item.otherexpenses
                    });
                    this.agentViewExcel.push({
                        SNo: this.agentViewExcel.length + 1, AgentName: item.firmName, Jurisdiction: item.serviceJurisdiction,
                        IPType: item.category, TypeofService: item.particulars,
                        Officialfee: item.officialfee, ProfessionalFee: item.professionalfee, OtherExpenses: item.otherexpenses,
                        Total: item.total
                    });
                });
                prevState.items = this.allItems;
                prevState.selectedJurisdiction.splice(0, this.state.selectedJurisdiction.length);
                prevState.selectedParticular.key = '';
                prevState.selectedParticular.text = '';
                prevState.selectedService.key = '';
                prevState.selectedService.text = '';
                return prevState;
            });
        } catch (exception) {
            this.handleError("Timed out", "Your session has expired. Please login again.");
        }
    }
    private loadServices(): void {
        this.setState((prevState: IAgentViewState): IAgentViewState => {
            var result: IComboBoxOption[] = [];
            result.push(
                { key: 'Trade mark', text: 'TRADE MARK' },
                { key: 'PatentS', text: 'PATENTS' },
                { key: 'Design', text: 'DESIGN' },
                { key: 'Hourly rate prosecution', text: 'HOURLY RATE PROSECUTION' }
            );
            prevState.services = result;
            return prevState;
        });
    }
    private loadParticulars = async (): Promise<void> => {
        try {
            var lookup = {};
            let result: IComboBoxOption[] = [];
            const selectedService = this.state.selectedService.text || undefined;
            this.setState((prevState: IAgentViewState): IAgentViewState => {
                if (selectedService !== undefined) {
                    const filteredItems = this.allItems.filter(tech => tech.category === selectedService).sort((a, b) => a.particulars > b.particulars ? 1 : -1);
                    for (let item: IDetailsList, i = 0; item = filteredItems[i++];) {
                        let particulars: string = item.particulars;
                        if (!(particulars in lookup)) {
                            lookup[particulars] = 1;
                            let itemToInsert: IComboBoxOption = { key: item.key, text: item.particulars };
                            result.push(itemToInsert);
                        }
                    }
                }
                prevState.particulars = result;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Timed out", "Your session has expired. Please login again.");
        }
    }
    private loadCountries = async (): Promise<void> => {
        try {
            var result: IComboBoxOption[] = [];
            let countryList: ICountry[] = await this.props.connectionContext.get("Country");
            this.setState((prevState: IAgentViewState): IAgentViewState => {
                countryList = countryList.sort((a, b) => a.countryName > b.countryName ? 1 : -1)
                countryList.forEach((item: ICountry) => {
                    result.push(
                        { key: item.countryCode, text: item.countryName })
                });
                prevState.jurisdictions = result;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Timed out", "Your session has expired. Please login again.");
        }
    }
    private getAgentProfile = async (item: IDetailsList): Promise<void> => {
        try {
            this.setState((prevState: IAgentViewState): IAgentViewState => {
                prevState.agentId = item.agentId;
                prevState.hideModel = false;
                return prevState;
            });
        } catch (exception) {
            this.handleError("Message", "Unable to process at the moment. Please try again or contact agent.network@zacco.com.");
        }
    }
    public render(): React.ReactElement<IAgentViewProps> {
        const stackTokens: IStackTokens = { childrenGap: 20 };
        const { items } = this.state;
        const fileName = "AgentCharges";
        return (
            <div className={panel}>
                {
                    (!this.state.loading) && (
                        <div>
                            {
                                <div>
                                    <div>
                                        <Dialog
                                            hidden={this.state.hideModel}
                                            dialogContentProps={{
                                                type: DialogType.largeHeader,
                                                title: this.dialog.dialogMessage,
                                            }}
                                            minWidth="80%"
                                            maxWidth="100%"
                                            closeButtonAriaLabel="Ok"
                                        >
                                            <div>
                                                <div>
                                                    <AgentProfile connectionContext={this.connectionContext} agentId={this.state.agentId}
                                                        onClose={this.closeChild} />
                                                </div>
                                            </div>
                                        </Dialog>
                                    </div>
                                </div>
                            }
                            {
                                <div className={filterPanel}>
                                    <div className={innerPanel}>
                                        <div className={textBoxPanel}>IP Type</div>
                                        <div className={textBoxPanel}>
                                            <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                <ComboBox
                                                    placeholder="Select or type"
                                                    allowFreeform
                                                    autoComplete="on"
                                                    options={this.state.services}
                                                    onChange={this.onChangeService}
                                                    errorMessage={this.serviceError}
                                                    defaultSelectedKey={this.state.selectedService.key ? this.state.selectedService.key : undefined}
                                                />
                                            </Stack>
                                        </div>
                                        <div className={textBoxPanel}>Type of Service</div>
                                        <div className={textBoxPanel}>
                                            <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                <ComboBox
                                                    placeholder="Select or type"
                                                    allowFreeform
                                                    autoComplete="on"
                                                    options={this.state.particulars}
                                                    onChange={this.onChangeParticular}
                                                    errorMessage={this.contentError}
                                                    defaultSelectedKey={this.state.selectedParticular.key ? this.state.selectedParticular.key : undefined}
                                                />
                                            </Stack>
                                        </div>
                                        <div className={textBoxPanel}>Jurisdiction</div>
                                        <div className={textBoxPanel}>
                                            <Stack horizontal tokens={stackTokens} verticalAlign="end">
                                                <ComboBox
                                                    placeholder="Select or type"
                                                    allowFreeform
                                                    autoComplete="on"
                                                    options={this.state.jurisdictions}
                                                    onChange={this.onChangeJurisdiction}
                                                    errorMessage={this.jurisdictionError}
                                                    multiSelect
                                                />
                                            </Stack>
                                        </div>
                                    </div>
                                    <div className={innerPanel}>
                                        <div className={textBoxPanel}>
                                            <PrimaryButton type="submit" value="Search" text="Go" onClick={this.submitForm} className={submitButton} iconProps={{ iconName: "Filter" }} />
                                        </div>
                                        <div className={textBoxPanel}>
                                            <PrimaryButton type="submit" value="Search" text="Refresh" onClick={this.refreshForm} className={submitButton} iconProps={{ iconName: "ClearFilter" }} />
                                        </div>
                                        <div className={printButtonPanel}>
                                            <PrimaryButton type="submit" value="Search" text="Print" onClick={() => window.print()} className={submitButton} iconProps={{ iconName: "Print" }} />
                                        </div>
                                        <div className={textBoxPanel}>
                                            <ExportCSV csvData={this.agentViewExcel} fileName={fileName} /></div>
                                    </div>
                                </div>
                            }
                            {
                                <div>
                                    <div className={userMessage}>
                                        Search by a keyword:
                                    </div>
                                    <div>
                                        <SearchBox required placeholder="Search by a keyword" styles={getStyles} onChange={this.onFilter} />
                                    </div>
                                    <div className={userMessage}>
                                        * Click on the agent name to view and download the agent's profile
                                    </div>
                                    <div className={listPanel}>
                                        <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                                            <MarqueeSelection selection={this.selection}>
                                                <DetailsList
                                                    items={items}
                                                    columns={this.columns}
                                                    setKey="set"
                                                    layoutMode={DetailsListLayoutMode.justified}
                                                    selection={this.selection}
                                                    selectionPreservedOnEmptyClick={false}
                                                    ariaLabelForSelectionColumn="Toggle selection"
                                                    ariaLabelForSelectAllCheckbox="Toggle selection for all items"
                                                    checkButtonAriaLabel="Row checkbok"
                                                    onItemInvoked={this.onItemInvoked}
                                                    selectionMode={1}
                                                    compact
                                                    checkboxVisibility={CheckboxVisibility.hidden}
                                                    constrainMode={ConstrainMode.horizontalConstrained}
                                                    isHeaderVisible={true}
                                                    onRenderDetailsHeader={this.onRenderDetailsHeader}
                                                />
                                            </MarqueeSelection>
                                        </ScrollablePane>
                                    </div>
                                </div>
                            }
                        </div>
                    )
                }
            </div>
        );
    }
    private onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (props, defaultRender) => {
        if (!props) {
            return null;
        }
        return (
            <Sticky stickyPosition={StickyPositionType.Header} isScrollSynced>
                {defaultRender!({
                    ...props
                })}
            </Sticky>
        );
    };
    private onChangeService: IComboBoxProps['onChange'] = (event, option): void => {
        this.setState((prevState: IAgentViewState): IAgentViewState => {
            if (option) {
                prevState.selectedService = option;
            }
            prevState.selectedParticular.key = '';
            prevState.selectedParticular.text = '';
            return prevState;
        }, () => this.loadParticulars());
    }
    private onChangeParticular: IComboBoxProps['onChange'] = (event, option): void => {
        this.setState((prevState: IAgentViewState): IAgentViewState => {
            if (option) {
                prevState.selectedParticular = option;
            }
            else {
                prevState.selectedParticular.key = '';
                prevState.selectedParticular.text = '';
            }
            return prevState;
        });
    }
    private onChangeJurisdiction: IComboBoxProps['onChange'] = (event, option): void => {
        if (option) {
            this.setState((prevState: IAgentViewState): IAgentViewState => {

                const newSelectedItems = [...this.state.selectedItems];
                if (option.selected) {
                    newSelectedItems.push(option.key as string);
                    prevState.selectedJurisdiction.push(option);
                    prevState.selectedItems = newSelectedItems;
                }
                else {
                    const currIndex = newSelectedItems.indexOf(option.key as string);
                    if (currIndex > -1) {
                        newSelectedItems.splice(currIndex, 1);
                        prevState.selectedItems = newSelectedItems;
                        prevState.selectedJurisdiction.forEach((listitem: IComboBoxOption) => {
                            if (option.text === listitem.text) {
                                let index = this.state.selectedJurisdiction.indexOf(listitem);
                                prevState.selectedJurisdiction = prevState.selectedJurisdiction.slice(0, index).concat(prevState.selectedJurisdiction.slice(index + 1));
                            }
                        });
                    }
                }
                return prevState;
            });
        }
    }
    private submitForm = (): void => {
        const selectedService: boolean = this.state.selectedService.key.toString().length > 0 && this.state.selectedService.key.toString() !== "";
        const selectedParticular: boolean = this.state.selectedParticular.key.toString().length > 0 && this.state.selectedParticular.key.toString() !== "";
        const selectedJurisdiction: boolean = this.state.selectedJurisdiction.length > 0;
        this.allItemsExcel = [];
        this.setState((prevState: IAgentViewState): IAgentViewState => {
            prevState.items = [];
            if (selectedService && selectedParticular && selectedJurisdiction) {
                this.state.selectedJurisdiction.forEach((data: IComboBoxOption) => {
                    let filteredItem: IDetailsList[] = [];
                    filteredItem = this.allItems.filter(i => i.category.indexOf(this.state.selectedService.text) > -1 && i.particulars.indexOf(this.state.selectedParticular.text) > -1
                        && i.jurisdiction.indexOf(data.text) > -1);
                    if (filteredItem.length > 0) {
                        prevState.items = filteredItem;
                        this.allItemsExcel = filteredItem;
                    }
                })
            }
            if (selectedService && !selectedParticular && selectedJurisdiction) {
                this.state.selectedJurisdiction.forEach((data: IComboBoxOption) => {
                    let filteredItem: IDetailsList[] = [];
                    filteredItem = this.allItems.filter(i => i.category.indexOf(this.state.selectedService.text) > -1 && i.jurisdiction.indexOf(data.text) > -1);
                    if (filteredItem.length > 0) {
                        prevState.items = filteredItem;
                        this.allItemsExcel = filteredItem;
                    }
                })
            }
            if (selectedService && selectedParticular && !selectedJurisdiction) {
                prevState.items = this.allItems.filter(i => i.category.indexOf(this.state.selectedService.text) > -1 && i.particulars.indexOf(this.state.selectedParticular.text) > -1);
                this.allItemsExcel = this.allItems.filter(i => i.category.indexOf(this.state.selectedService.text) > -1 && i.particulars.indexOf(this.state.selectedParticular.text) > -1);
            }
            if (selectedService && !selectedParticular && !selectedJurisdiction) {
                prevState.items = this.allItems.filter(i => i.category.indexOf(this.state.selectedService.text) > -1);
                this.allItemsExcel = this.allItems.filter(i => i.category.indexOf(this.state.selectedService.text) > -1);
            }
            if (!selectedService && !selectedParticular && selectedJurisdiction) {
                this.state.selectedJurisdiction.forEach((data: IComboBoxOption) => {
                    let filteredItem: IDetailsList[] = [];
                    filteredItem = this.allItems.filter(i => i.jurisdiction.indexOf(data.text) > -1);
                    if (filteredItem.length > 0) {
                        prevState.items = filteredItem;
                        this.allItemsExcel = filteredItem;
                    }
                })
            }
            if (!selectedService && selectedParticular && !selectedJurisdiction) {
                prevState.items = this.allItems.filter(i => i.particulars.indexOf(this.state.selectedParticular.text) > -1);
                this.allItemsExcel = this.allItems.filter(i => i.particulars.indexOf(this.state.selectedParticular.text) > -1);
            }
            if (!selectedService && !selectedParticular && !selectedJurisdiction) {
                prevState.items = this.allItems;
                this.allItemsExcel = this.allItems;
            }
            this.agentViewExcel = [];
            this.allItemsExcel.forEach((item: IDetailsList) => {
                this.agentViewExcel.push({
                    SNo: this.agentViewExcel.length + 1, AgentName: item.firmName, Jurisdiction: item.jurisdiction,
                    IPType: item.category, TypeofService: item.particulars,
                    Officialfee: item.officialfee, ProfessionalFee: item.professionalfee, OtherExpenses: item.otherexpenses,
                    Total: item.total
                });
            });
            return prevState;
        });
    }
    private refreshForm = (): void => {
        this.getAgentInfo();
        this.loadServices();
        this.loadParticulars();
        this.loadCountries();
    }
    private getSelectionDetails(): string {
        const selectionCount = this.selection.getSelectedCount();
        switch (selectionCount) {
            case 0:
                return 'No Agent(s) selected';
            case 1:
                return '1 agent selected: ' + (this.selection.getSelection()[0] as IDetailsList).firmName;
            default:
                return `${selectionCount} agents selected`;
        }
    }
    private onFilter = (event?: React.ChangeEvent<HTMLInputElement>, value?: string): void => {
        this.setState({
            items: value ? this.allItems.filter(i => i.firmName.toLowerCase().indexOf(value) > -1 || i.jurisdiction.toLowerCase().indexOf(value) > -1
                || i.category.toLowerCase().indexOf(value) > -1 || i.particulars.toLowerCase().indexOf(value) > -1) : this.allItems
        });
        this.allItemsExcel = [];
        this.agentViewExcel = [];
        this.allItemsExcel = value ? this.allItems.filter(i => i.firmName.toLowerCase().indexOf(value) > -1 || i.jurisdiction.toLowerCase().indexOf(value) > -1
            || i.category.toLowerCase().indexOf(value) > -1 || i.particulars.toLowerCase().indexOf(value) > -1) : this.allItems
        this.allItemsExcel.forEach((item: IDetailsList) => {
            this.agentViewExcel.push({
                SNo: this.agentViewExcel.length + 1, AgentName: item.firmName, Jurisdiction: item.jurisdiction,
                IPType: item.category, TypeofService: item.particulars,
                Officialfee: item.officialfee, ProfessionalFee: item.professionalfee, OtherExpenses: item.otherexpenses,
                Total: item.total
            });
        });
    };
    private onItemInvoked = (item: IDetailsList): void => {
        alert(`Agent invoked: ${item.firmName}`);
    };
    private handleError(message: string, body: string) {
        this.dialog.dialogMessage = message;
        this.dialog.dialogBody = body;
        this.dialog.accessDeniedDialog = false;
        this.dialog.hideDialog = false;
        this.setState((previousState: IAgentViewState, props: IAgentViewProps): IAgentViewState => {
            previousState.loading = false;
            return previousState;
        });
    }
    private closeChild = () => {
        this.setState({
            hideModel: true
        });
    }
}